import ResearchGroupIntro from '../Components/ResearchGroupIntro';

const FinLawIntro = () => {
    return <ResearchGroupIntro route="/finLaw" />;
}
export default FinLawIntro;
